import React from 'react'
import ReggoraChatBubble from './ReggoraBubble'
import { ReggoraChatBubble as NewChatBubble } from '@reggora-app/reggora-conversation-ui'
import { ChatFeed } from 'react-chat-ui'
import API, { API_VERSION, REQUEST_METHOD } from '../../api'

const fetchAuditData = async (auditId) => {
  const audit = await API(
    `lender/auto-message-audit/${auditId}`,
    API_VERSION.v2
  ).request(REQUEST_METHOD.GET)
  return audit
}

export const ChatWrapper = ({
  total_chat_timeline,
  timelineData,
  isUnifiedConversation,
  isAMPUser,
  customFieldLabels = {},
}) => {
  const useNewChatBubble = isUnifiedConversation && !isAMPUser

  // For new bubble, inject fetchAuditData and customFieldLabels into messages
  const messagesWithFetch = useNewChatBubble
    ? total_chat_timeline.map(msg =>
      Array.isArray(msg) ? msg : { ...msg, fetchAuditData, customFieldLabels }
    )
    : total_chat_timeline

  return (
    <ChatFeed
      messages={messagesWithFetch}
      chatBubble={useNewChatBubble ? NewChatBubble : ReggoraChatBubble}
      showSenderName={false}
      timelineEvents={timelineData}
    />
  )
}
